module.exports = __webpack_public_path__ + "img/seringa.24980429.png";